module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_7.3919c8f8.png";